<template>
  <exception-page type="600"/>
</template>

<script>
import ExceptionPage from './components/ExceptionPage'

export default {
  name: 'e600',
  components: {
    ExceptionPage
  }
}
</script>

<style scoped>
</style>
